// @flow

import React, {Component} from 'react';
import { connect } from 'react-redux';

import { loginUsernamePassword, recoverPassword } from '../../actions';

import { LoginProps, LoginState } from "../../TypeDefinitions";

import {validateField, validateForm} from "../../../../services/validate";

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import muiThemeable from "material-ui/styles/muiThemeable";
import {ALERT_OPEN} from "../../../../actions/actionTypes";
import {REGISTER_CHANGE_PASSWORD_INVALID_EMAIL} from "../../../../lang/alerts";

import { FormattedMessage } from 'react-intl';

class Login extends Component <LoginProps, LoginState> {

    state = {
        values: {
            email: '',
            password: ''
        },
        errors: {
            email: null,
            password: null
        },
        rules: {
            email: {
                required: 'Email is required',
                isEmail: 'Email is not valid'
            },
            password: {
                required: 'Password is required',
                validPassword: 'Password should have more than 7 characters'
            },
        }
    };

    updateField = (e, value) => {
        const name = e.target.name;

        const rules = this.state.rules[name];

        let is_valid = validateField(name, rules, value);

        this.setState(prevState => ({
            values: {...prevState.values, [name]: value},
            errors: {...prevState.errors, [name]: is_valid}
        }));
    };

    loginAction = (e) => {
        e.preventDefault();

        if (!validateForm(this.state.errors)) return false;

        const { email, password } = this.state.values;

        if (email && password) {
            this.props.login(email, password);
        }
    };

    recoverPasswordAction = (e) => {
        e.preventDefault();

        const { email } = this.state.values;

        const rules = this.state.rules['email'];

        let has_errors = validateField('email', rules, email);

        if (!has_errors){
            this.props.recoverPassword(email);
        }else{
            this.props.recoverPasswordEmailNotValid();
        }
    };


    render() {
        return (
            <div className='spacing-bottom'>
                <TextField
                    name="email"
                    ref="email"
                    id="personal_email"
                    style={this.props.muiTheme.personal.textField}
                    defaultValue={this.state.values.email}
                    hintText={
                        <FormattedMessage
                            id="checkout.email"
                            defaultMessage="Email"
                        />
                    }
                    type="email"
                    errorText={this.state.errors.email}
                    onChange={this.updateField}
                />
                <TextField
                    name="password"
                    ref="password"
                    id="personal_password"
                    style={this.props.muiTheme.personal.textField}
                    defaultValue={this.state.values.password}
                    hintText={
                        <FormattedMessage
                            id="checkout.password"
                            defaultMessage="Password"
                        />
                    }
                    type="password"
                    errorText={this.state.errors.password}
                    onChange={this.updateField}
                />
                <RaisedButton
                    label="Login"
                    className="loginBtn-2"
                    primary={true}
                    style={this.props.muiTheme.personal.buttons.yes}
                    onClick={this.loginAction}
                    secondary={true}
                />
                <span className="text--main">Forgot Password? Reset it <a href="/forgot-password" onClick={this.recoverPasswordAction}>here</a></span>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    login: (username, password) => dispatch(loginUsernamePassword({
        username, password, realm: process.env.REACT_APP_AUTH0_CONNECTION, redirect: `${window.location.origin}/cart`,
    })),
    recoverPassword: (email) => dispatch(recoverPassword({ email, connection: process.env.REACT_APP_AUTH0_CONNECTION })),
    recoverPasswordEmailNotValid: () => dispatch({ type: ALERT_OPEN, message: REGISTER_CHANGE_PASSWORD_INVALID_EMAIL })
});

export default muiThemeable()(connect(() => ({}), mapDispatchToProps)(Login));